import { Link } from 'react-router-dom';
import { Icon } from '../lib/icons';

export function ServiceCard({
  title,
  description,
  icon,
  href,
  cta
}: {
  title: string;
  description: string;
  icon: string;
  href: string;
  cta: string;
}) {
  return (
    <article className="group rounded-lg border border-brand-border bg-white p-6 shadow-card transition duration-200 hover:-translate-y-1 hover:shadow-soft">
      <div className="flex h-12 w-12 items-center justify-center rounded-md bg-brand-background text-brand-navy">
        <Icon name={icon} className="h-6 w-6" />
      </div>
      <h3 className="mt-6 text-xl font-extrabold text-brand-dark">{title}</h3>
      <p className="mt-3 text-sm leading-7 text-brand-muted">{description}</p>
      <Link to={href} className="mt-6 inline-flex items-center gap-2 text-sm font-extrabold text-brand-navy">
        {cta} <Icon name="arrowRight" className="h-4 w-4 transition group-hover:translate-x-1" />
      </Link>
    </article>
  );
}
